<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/stock/adjusts">{{ $t('stock_adjust_list') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('new') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <b-btn variant="outline-primary no-bor" size="sm" @click="save"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{ $t('branch') }}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="header.BranchId">
                                        <option v-for="ret in branchs" :value="ret.Id" :key="ret.Id">{{ ret.Name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{ $t('date') }}</label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="header.Date" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="control-label blue">{{ $t('remark') }}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="header.Remark" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="grid">
                                <thead>
                                <tr class="blue">
                                    <th>{{$t('item_name')}}</th>
                                    <th style="width: 120px;">{{$t('qty_old')}}</th>
                                    <th style="width: 120px;">{{$t('qty_new')}}</th>
                                    <th style="width: 20px;"></th>
                                </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret,index) in lines" :key="index">
                                        <td><AuthCompleted @select="select($event, ret)" :value="ret.ItemName" :disabled="header.BranchId==''"></AuthCompleted></td>
                                        <td class="text-right">
                                            <input type="number" class="form-control form-control-sm" v-model="ret.Quantity" readonly />
                                        </td>
                                        <td class="text-right">
                                            <input type="number" class="form-control form-control-sm" v-model="ret.QuantityNew" />
                                        </td>
                                        <td class="text-right"><a href="javascript:void(0)" class="red" @click="removeLine(index)"><i aria-hidden="true" class="fa fa-times-circle"></i></a></td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td class="none-left">
                                            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="addLine"><i class="fa fa-plus"/> {{ $t('add_line') }}</button>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { AuthCompleted } from '../Item';
    export default {
        components: {
            AuthCompleted,
        },
        data: function(){
            return {
                branchs: [],
                header: {
                    BranchId: '',
                    Date: this.$now().format('YYYY-MM-DD')
                },
                lines: [
                    {
                        ItemId: '',
                        ItemName: '',
                        Quantity: 0,
                        QuantityNew: 0
                    }
                ]
            }
        },
        mounted(){
            this.branchList();
            let id = this.$route.params.id;
            if(id != undefined && id != ''){
                this.findById(id);
            }
        },
        methods: {
            branchList(){
                this.$api().post('branch/list', { Limit: 0 }).then(res => {
                    if(this.$isValid(res)){
                        this.branchs = res.data.Data;
                    }
                });
            },
            findById(id){
                let loading = this.$loading.show();
                this.$api().post('stock/adjust/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.header = res.data.Json.AdjustHead;
                        this.header.Date = this.$format(this.header.Date, 'YYYY-MM-DD');
                        this.lines = res.data.Json.AdjustLines;
                    }
                }).finally(function(){ loading.hide(); });
            },
            save(){
                let loading = this.$loading.show();
                let req = {
                    Header: this.header,
                    Lines: this.lines
                };
                this.$api().post('stock/adjust/save', req).then(res => {
                    if(this.$isValid(res)){
                        this.$router.go(-1);
                    }
                }).finally(function(){ loading.hide(); });
            },
            select(e, item){
                item.ItemId = e.Id;
                item.ItemName = e.Name;
                this.findStockOnHand(item);
            },
            findStockOnHand(item){
                let loading = this.$loading.show();
                this.$api().post('stock/onhand/find', { Id: item.ItemId, BranchId: this.header.BranchId }).then(res => {
                    if(this.$isValid(res)){
                        item.Quantity = res.data.Json.Onhand.Quantity;
                    }
                }).finally(function(){ loading.hide(); });
            },
            addLine(){
                this.lines.push({
                    ItemId: '',
                    ItemName: '',
                    Quantity: 0,
                    QuantityNew: 0
                });
            },
            removeLine(index){
                if(this.lines.length > 1){
                    this.lines.splice(index, 1);
                }
            }
        }
    }
</script>
